import { createFileRoute, redirect } from '@tanstack/react-router';

/** The old address of the day view; it now lives on the dashboard. */
export const Route = createFileRoute('/_app/my-day')({
  beforeLoad: () => {
    throw redirect({ to: '/dashboard' });
  },
});
